import GranadaData from "../../../../src/components/granada-data.js";
import * as React from 'react';
export default {
  GranadaData,
  React
};